/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useState, useCallback, useEffect } from "react";
import { TextField } from "@mui/material";
import { debounce } from "lodash";
import { FormLabel } from "./form-label";
import { ServiceListIconLinkEditWrapper } from "./icon-link-wrapper";
import { ServiceListIconLink } from "./icon-link/icon-link";

const ServiceListTabContent = (props) => {
    
    const {
        isCurrent,
        tab,
        updateTab,
    } = props;
    const {
        guid,
        title: _title,
        icon_links: _icon_links = [],
    } = tab || {};
    
    const [currentTab, setCurrentTab] = useState(tab);
    const [title, setTitle] = useState(_title);
    const [icon_links, setIcon_links] = useState(_icon_links);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const update = useCallback(
        debounce((guid, previous, next) => {
            setCurrentTab(previous);
            updateTab(guid, previous, next);
        }, 500),
        [updateTab]
    );
    
    useEffect(
        () => {
            const nextTab = { ...currentTab, title, icon_links };
            update(guid, currentTab, nextTab);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [title, icon_links]
    );
    
    const onTitleChange = (event) => {
        const newTitle = event.target.value;
        setTitle(newTitle);
    };

    const onIconLinksChange = (newIconLinks) => {
        setIcon_links(newIconLinks);
    };
    
    return (
        <Fragment>
            {isCurrent &&
                <>
                    <FormLabel text='Tab Title' />
                    <TextField
                        id='title'
                        value={title}
                        onChange={onTitleChange}
                        fullWidth={true}
                        style={{ marginBottom: "16px" }}
                    />
                    
                    <FormLabel text='Icon Links' />
                    <ServiceListIconLinkEditWrapper
                        icon_links={icon_links}
                        onChangeList={onIconLinksChange}
                    >
                        <ServiceListIconLink />
                    </ServiceListIconLinkEditWrapper>
                </>
            }
        </Fragment>
    );
};

ServiceListTabContent.displayName = "ServiceListTabContent";
export { ServiceListTabContent }; 
